export const featuredServices = [
  {
    title: { en: 'Concrete Work', es: 'Trabajos de Concreto' },
    description: {
      en: 'From foundations to driveways, we handle all your concrete needs with precision and expertise. Professional installation and finishing.',
      es: 'Desde cimientos hasta entradas de autos, atendemos todas tus necesidades de concreto con precisión y experiencia. Instalación y acabado profesional.',
    },
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/6fba2d70-e265-4bb4-a2b9-4e4987a52268.jpg',
    alt: {
      en: 'Newly finished broom-textured concrete driveway in front of a brick home',
      es: 'Entrada de concreto recién terminada frente a una casa de ladrillo',
    },
    tags: [
      { en: 'Driveways', es: 'Entradas' },
      { en: 'Foundations', es: 'Cimientos' },
      { en: 'Patios', es: 'Patios' },
      { en: 'Sidewalks', es: 'Banquetas' },
    ],
  },
  {
    title: { en: 'Asphalt Paving', es: 'Pavimentación de Asfalto' },
    description: {
      en: 'Professional asphalt paving for driveways, parking lots, and roads. Durable, long-lasting surfaces built to last.',
      es: 'Pavimentación profesional de asfalto para entradas, estacionamientos y calles. Superficies resistentes, hechas para durar.',
    },
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/0fa61965-eb20-4d94-bc78-b701a3b3d27a.jpg',
    alt: {
      en: 'Freshly paved and striped asphalt parking lot',
      es: 'Estacionamiento de asfalto recién pavimentado y señalizado',
    },
    tags: [
      { en: 'Driveways', es: 'Entradas' },
      { en: 'Parking lots', es: 'Estacionamientos' },
      { en: 'Roads', es: 'Calles' },
      { en: 'Striping', es: 'Señalización' },
    ],
  },
];

export const supportServices = [
  {
    title: { en: 'Repairs & Maintenance', es: 'Reparación y Mantenimiento' },
    description: {
      en: 'Keep your concrete and asphalt in top condition with our professional repair and maintenance services.',
      es: 'Mantén tu concreto y asfalto en óptimas condiciones con nuestros servicios profesionales de reparación y mantenimiento.',
    },
    cta: { en: 'Learn More', es: 'Más Información' },
  },
  {
    title: { en: 'Free Estimates', es: 'Estimados Gratis' },
    description: {
      en: "Contact us for a free, no-obligation estimate on your project. We're ready to discuss your construction needs.",
      es: 'Contáctanos para un estimado gratuito y sin compromiso. Estamos listos para hablar de tu proyecto.',
    },
    cta: { en: 'Get Free Estimate', es: 'Obtén un Estimado Gratis' },
  },
];

export const learnMore = { en: 'Learn More', es: 'Más Información' };

export const serviceOptions = [
  { id: 'concrete', label: { en: 'Concrete Work', es: 'Trabajos de Concreto' } },
  { id: 'asphalt', label: { en: 'Asphalt Paving', es: 'Pavimentación de Asfalto' } },
  { id: 'repairs', label: { en: 'Repairs & Maintenance', es: 'Reparación y Mantenimiento' } },
  { id: 'other', label: { en: 'Other', es: 'Otro' } },
];
